import React, { Component } from 'react'
import Firebase from "firebase/app"
import 'firebase/database'

// Check more icons at here https://react-icons.github.io/react-icons/icons?name=fa
import { FaCheckCircle, FaPlus } from 'react-icons/fa'

import CustomParkingPicker from './CustomAdminComponents/CustomParkingPicker'
import ParkingDisplay from './CustomAdminComponents/ParkingDisplay'
import CustomParkingTable from './CustomAdminComponents/CustomParkingTable'

import {ThemeProvider} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import {appTheme, validateField} from '../../utils'

import {
    CREATE_STATE,
    FOUND_STATE,
    DELETED_STATE,
    CREATE_SUCCESS_STATE,
    CREATE_FAILED_STATE,
    UPDATE_SUCCESS_STATE,
    UPDATE_FAILED_STATE,
    NOT_CHOOSEN_STATE,
    NUMBER_FIELD,
    STRING_FIELD
} from "../../constants"

import {
    CHOOSE_AN_OPTION_TEXT
} from '../../strings'

import "react-datepicker/dist/react-datepicker.css";

class ParkingAdmin extends Component {

    constructor(props) {
        super(props)

        this.state = {
            parkings: {},
            reservedParkings: {},
            currentOccupation: {},
            selectedParkingId: null,
            selectedTime: new Date().getTime(),
            parkingState: NOT_CHOOSEN_STATE,
            errorMessages: {
                invalidName: false,
                invalidCapacity: false,
                invalidPriority: false
            }
        }

        this.reservedParkingsRef = Firebase.database().ref('/reservedParkings')
        this.parkingsRef = Firebase.database().ref('/parkings')

        this.handleParkingChange = this.handleParkingChange.bind(this)
        this.handleParkingCreate = this.handleParkingCreate.bind(this)
        this.handleParkingNameChange = this.handleParkingNameChange.bind(this)
        this.handleParkingCapacityChange = this.handleParkingCapacityChange.bind(this)
        this.handleClickUpdate = this.handleClickUpdate.bind(this)
        this.getParkingErrors = this.getParkingErrors.bind(this)
        this.handleClickDelete = this.handleClickDelete.bind(this)
        this.handlePriorityChange = this.handlePriorityChange.bind(this)
        this.handleTimeChange = this.handleTimeChange.bind(this)
    }

    handleParkingChange(event){
        const {reservedParkingsRef, parkingsRef} = this
        const value = event.target.value
        reservedParkingsRef.off()
        parkingsRef.off()

        if (value === CHOOSE_AN_OPTION_TEXT){
            this.setState({
                parkingState: NOT_CHOOSEN_STATE,
                selectedParkingId: null,
                reservedParkings: {},
                currentOccupation: {},
                errorMessages: {
                    invalidName: false,
                    invalidCapacity: false
                }
            })
            return
        }
        // Create a new listener on future reservedSpaces for this parking lot
        const nowTimestamp = new Date().getTime()
        reservedParkingsRef.child(`/${value}`).orderByKey().startAt(nowTimestamp.toString()).on(
            'value', snapshot => {
                var parkingsRaw = snapshot.val();
                if (parkingsRaw === null){
                    parkingsRaw = {}
                }
                this.setState({
                    reservedParkings: parkingsRaw
                })
        })

        parkingsRef.child(`/${value}/currentOccupation`).on('value', snapshot => {
            var occupationRaw = snapshot.val()
            if (occupationRaw === null){
                occupationRaw = {}
            }
            this.setState({
                currentOccupation: occupationRaw
            })
        })

        this.setState({
            parkingState: FOUND_STATE,
            selectedParkingId: value,
            errorMessages: {
                invalidName: false,
                invalidCapacity: false
            }
        })
    }

    handleParkingCreate(){
        const {reservedParkingsRef, parkingsRef} = this
        const {parkings} = this.state

        reservedParkingsRef.off()
        parkingsRef.off()
        // Get the current lowest priority
        const allPriorities = Object.keys(parkings).map(
            parkingId => {return parkings[parkingId].priority}
        ).filter(el => el != null)
        allPriorities.sort()
        var lowestPriority = allPriorities.length > 0 ? allPriorities[allPriorities.length - 1] : 0
        const newParking = {
            name: '',
            capacity: 0,
            available: 0,
            priority: lowestPriority + 1
        }
        const newParkingId = Math.random().toString(36).substr(2, 9)
        parkings[newParkingId] = newParking
        this.setState({
            selectedParkingId: newParkingId,
            parkingState: CREATE_STATE,
            parkings: parkings,
            reservedParkings: {},
            currentOccupation: {},
            errorMessages: {
                invalidName: false,
                invalidCapacity: false
            }
        })
    }

    handleParkingNameChange(event){
        const {parkings, selectedParkingId, errorMessages} = this.state
        const newName = event.target.value
        parkings[selectedParkingId].name = newName
        if (!validateField(STRING_FIELD, newName)){
            errorMessages.invalidName = true
        } else {
            errorMessages.invalidName = false
        }

        this.setState({
            parkings: parkings,
            errorMessages: errorMessages
        })
    }

    handleParkingCapacityChange(event){
        const {parkings, selectedParkingId, errorMessages} = this.state
        const newCapacity = event.target.value
        if (!validateField(NUMBER_FIELD, newCapacity)){
            errorMessages.invalidCapacity = true
        } else {
            errorMessages.invalidCapacity = false
        }
        parkings[selectedParkingId].capacity = newCapacity
        this.setState({
            parkings: parkings,
            errorMessages: errorMessages
        })
    }

    handleClickUpdate(event){
        const {parkings, selectedParkingId, parkingState, errorMessages} = this.state
        // Perform one last sanity check
        const isCreate = parkingState === CREATE_STATE || parkingState === CREATE_FAILED_STATE
        if (!validateField(STRING_FIELD, parkings[selectedParkingId].name)){
            errorMessages.invalidName = true
            this.setState({
                errorMessages: errorMessages,
                parkingState: isCreate ? CREATE_FAILED_STATE : UPDATE_FAILED_STATE
            })
            return
        }
        if (!validateField(NUMBER_FIELD, parkings[selectedParkingId].capacity)){
            errorMessages.invalidCapacity = true
            this.setState({
                errorMessages: errorMessages,
                parkingState: isCreate ? CREATE_FAILED_STATE : UPDATE_FAILED_STATE
            })
            return
        }

        // Update parking
        parkings[selectedParkingId].capacity = Number(parkings[selectedParkingId].capacity)
        parkings[selectedParkingId].priority = Number(parkings[selectedParkingId].priority)
        const parkingURL = `/parkings/${selectedParkingId}`
        Firebase.database().ref(parkingURL).update(parkings[selectedParkingId])

        // Update all parkings priorities
        for (var parkingId in parkings){
            if (parkings[parkingId].priority == null){
                // this is the Escoja una opcion "fake" parking lot
                continue
            }
            const parkingURL = `/parkings/${parkingId}`
            Firebase.database().ref(parkingURL).update({"priority": parkings[parkingId].priority})
        }

        this.setState({
            parkingState: isCreate ? CREATE_SUCCESS_STATE : UPDATE_SUCCESS_STATE
        })
    }

    getParkingErrors(){
        const {errorMessages} = this.state
        if (errorMessages.invalidName){
            return "El nombre del parqueo no es valido"
        }
        if (errorMessages.invalidCapacity){
            return "Numero invalido en capacidad de parqueo"
        }
        if (errorMessages.invalidPriority){
            return "Numero de prioridad es invalido"
        }
        return ""
    }

    handleClickDelete(){
        const {reservedParkingsRef, parkingsRef} = this
        const {selectedParkingId, parkings} = this.state
        const parkingURL = `/parkings/${selectedParkingId}`
        const reservedParkingURL = `/reservedParkings/${selectedParkingId}`
        reservedParkingsRef.off()
        parkingsRef.off()

        // Update parking priorities
        const allPriorities = Object.keys(parkings).map(
            parkingId => {return parkings[parkingId].priority}
        ).filter(el => el != null)
        allPriorities.sort()
        // Order parking Id by priority
        const newPrioritiesParkings = []
        for (var priorityFound in allPriorities){
            for (var foundParkingId in parkings){
                if (parkings[foundParkingId].priority === allPriorities[priorityFound]){
                    newPrioritiesParkings.push(foundParkingId)
                    break
                }
            }
        }
        var priorityToSet = 1
        for (var parkingIdIndex in newPrioritiesParkings){
            const pId = newPrioritiesParkings[parkingIdIndex]
            if (pId === selectedParkingId){
                continue
            }
            const priorityParkingURL = `/parkings/${pId}/priority`
            Firebase.database().ref(priorityParkingURL).set(priorityToSet)
            parkings[pId].priority = priorityToSet
            priorityToSet += 1
        }
        Firebase.database().ref(parkingURL).remove()
        Firebase.database().ref(reservedParkingURL).remove()
        delete parkings[selectedParkingId]
        this.setState({
            parkings: parkings,
            reservedParkings: {},
            currentOccupation: {},
            selectedParkingId: null,
            parkingState: DELETED_STATE
        })
    }

    handlePriorityChange(event){
        const {parkings, selectedParkingId, errorMessages} = this.state
        const newPriorityRaw = event.target.value
        const newPriority = newPriorityRaw.substring(0, newPriorityRaw.indexOf('.'))
        if (!validateField(NUMBER_FIELD, newPriority)){
            errorMessages.invalidPriority = true
        } else {
            errorMessages.invalidPriority = false
        }
        const oldPriority = parkings[selectedParkingId].priority
        parkings[selectedParkingId].priority = Number(newPriority)
        // Check if we have to change some other parking priority
        for (var parkingId in parkings){
            if (
                parkings[parkingId].priority === Number(newPriority) &&
                parkingId !== selectedParkingId
            ){
                parkings[parkingId].priority = oldPriority
                break
            }
        }
        this.setState({
            parkings: parkings,
            errorMessages: errorMessages
        })
    }

    handleTimeChange(fieldChange, value){
        const {reservedParkingsRef} = this
        const {selectedTime, selectedParkingId} = this.state
        reservedParkingsRef.off()

        var startDate = new Date(selectedTime)
        var newTimestamp = 0
        if (fieldChange === 'startDate'){
            value.setHours(startDate.getHours(), startDate.getMinutes())
            newTimestamp = value.getTime()
        } else if (fieldChange === 'startTime'){
            const hours = Number(value.substring(0, value.indexOf(':')))
            const minutes = Number(value.substring(value.indexOf(':') + 1))
            if (isNaN(hours) || isNaN(minutes)){
                return
            }
            startDate.setHours(hours, minutes)
            newTimestamp = startDate.getTime()
        }
        reservedParkingsRef.child(`/${selectedParkingId}`).orderByKey().startAt(newTimestamp.toString()).on(
            'value', snapshot => {
                var parkingsRaw = snapshot.val();
                if (parkingsRaw === null){
                    parkingsRaw = {}
                }
                this.setState({
                    reservedParkings: parkingsRaw
                })
        })

        this.setState({
            selectedTime: newTimestamp
        })
    }

    componentDidMount(){
        // Get all parking lots
        let parkingsRef = Firebase.database().ref('/parkings')

        parkingsRef.once('value', snapshot => {
            var parkingsRaw = snapshot.val();
            if (parkingsRaw === null){
                parkingsRaw = {}
            }
            for (var parkingId in parkingsRaw){
                // We do this to not update this field when user tries to
                // Current occupation is being fetched separately
                delete parkingsRaw['currentOccupation']
            }
            this.setState({
                parkings: parkingsRaw
            })
        })
    }

    render() {
        const {
            parkings,
            reservedParkings,
            selectedParkingId,
            selectedTime,
            parkingState,
            currentOccupation,
            errorMessages
        } = this.state
        const {
            handleParkingChange,
            handleParkingCreate,
            handleParkingNameChange,
            handleParkingCapacityChange,
            handlePriorityChange,
            handleClickUpdate,
            handleClickDelete,
            getParkingErrors,
            handleTimeChange
        } = this
        return (
            <div className="registerForm">
                <div className="shadow-box date-selection-block">
                    <div className="guests-block">
                        <div className="personal-data-block">
                            <CustomParkingPicker
                                parkings={[CREATE_STATE, CREATE_FAILED_STATE].includes(parkingState) ? {} : parkings}
                                selectedParkingId={selectedParkingId}
                                onParkingSelected={handleParkingChange}
                                disabled={[CREATE_STATE, CREATE_FAILED_STATE].includes(parkingState)}
                            />
                        </div>
                        <div>
                            <ThemeProvider theme={appTheme}>
                                <Button color="primary" variant="contained" onClick={handleParkingCreate} disabled={false}>
                                    <FaPlus/>Añadir parqueo
                                </Button>
                            </ThemeProvider>
                        </div>
                    </div>
                </div>
                <div>
                {
                    selectedParkingId ?
                        <div className="parking-info-box">
                            <div className="shadow-box date-selection-block">
                                <div>
                                    <ParkingDisplay
                                        parkings={parkings}
                                        selectedParkingId={selectedParkingId}
                                        errorMessages={errorMessages}
                                        disabled={
                                            [CREATE_SUCCESS_STATE, UPDATE_SUCCESS_STATE, DELETED_STATE].includes(parkingState)
                                        }
                                        onNameChange={handleParkingNameChange}
                                        onCapacityChange={handleParkingCapacityChange}
                                        onPriorityChange={handlePriorityChange}
                                    />
                                </div>
                                <div className="guests-block">
                                    <div className="inline-element horizontal-block">
                                        <input
                                            className="button-add-reserve"
                                            type="button"
                                            value={
                                                [CREATE_STATE, CREATE_FAILED_STATE, CREATE_SUCCESS_STATE].includes(parkingState) ?
                                                "Crear": "Actualizar"
                                            }
                                            disabled={[CREATE_SUCCESS_STATE, UPDATE_SUCCESS_STATE].includes(parkingState)}
                                            onClick={handleClickUpdate}/>
                                    </div>
                                    {
                                        [FOUND_STATE, UPDATE_FAILED_STATE, UPDATE_SUCCESS_STATE].includes(parkingState) ?
                                        <div className="inline-element horizontal-block">
                                            <input
                                                className="button-warning"
                                                type="button"
                                                value="Eliminar"
                                                disabled={[UPDATE_SUCCESS_STATE].includes(parkingState)}
                                                onClick={handleClickDelete}
                                            />
                                        </div> : <div></div>
                                    }
                                </div>
                                <div>
                                    {
                                        [UPDATE_FAILED_STATE, CREATE_FAILED_STATE].includes(parkingState) ?
                                            <div className="error-message">{getParkingErrors()}</div> :
                                            parkingState === UPDATE_SUCCESS_STATE ?
                                                <div className="text-success">
                                                    Actualizado correctamente<FaCheckCircle className="icon-check-circle"/>
                                                </div> :
                                            parkingState === DELETED_STATE ?
                                                <div className="text-error">
                                                    Eliminado correctamente <FaCheckCircle className="icon-check-circle"/>
                                                </div> :
                                            parkingState === CREATE_SUCCESS_STATE ?
                                                <div className="text-success">
                                                    Creado correctamente<FaCheckCircle className="icon-check-circle"/>
                                                </div> :
                                            <div> &nbsp;</div>
                                    }
                                </div>
                            </div>
                            {
                                [
                                    CREATE_STATE,
                                    CREATE_SUCCESS_STATE,
                                    CREATE_FAILED_STATE,
                                    DELETED_STATE
                                ].includes(parkingState)?
                                <div></div> :
                                <div>
                                    <CustomParkingTable
                                        timeSelected={selectedTime}
                                        selectedParkingId={selectedParkingId}
                                        parkings={parkings}
                                        expectedParkings={reservedParkings}
                                        currentOccupation={currentOccupation}
                                        onTimeChange={handleTimeChange}
                                        disabled={false}
                                    />
                                </div>
                            }
                        </div>:<div> </div>
                }
                </div>
            </div>
        )
    }
}

export default ParkingAdmin
